export const DESKTOP_SEARCH_MODAL_ID = 'desktopSearch';
